import React, { useEffect, useState } from 'react';
import { useSolicitudesDisponiblesModel } from '../../modelos/Solicitudes/modeloSolicitudes';
import { Solicitud } from '../../objetos/Solicitud/objeto_solicitud';
import RendersolicitudCard  from '../compartedRoutes/solicitudes/CardSolicitudestutor';
import { useNavigate } from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../modelos/Solicitudes/modeloSolicitud'; 
import ConfirmationDialog from '../../utils/confirmacionDialog'; 
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import { useUsers } from '../../metodos/userContext';
import RevisionTutor from './Usuario/RevisionTutor';
import CardSolicitud from '../compartedRoutes/solicitudes/CardSolicitud';

const DashboardSolciitudesTutor = () => {
  const navigate = useNavigate();
  const{
    solicitudesDisponibles,
    loadingSolicitudes,
    errorSolicitudes,
    cargarSolicitudes,
    setupWebSocketsSolicitudes,
  } = useSolicitudesDisponiblesModel();
  const [materiasDisponibles, setMateriasDisponibles] = useState([]);
  const [materiasFiltradas, setMateriasFiltradas] = useState([]);
  const [showMateriasFiltro, setShowMateriasFiltro] = useState(false);
  const [ordenFecha, setOrdenFecha] = useState('ascendente'); // 'ascendente' o 'descendente'
  const {configuracion,loadingConfiguracion} = useConfiguracion();

  const {usuario } = useUsers();

  // Estado para guardar las solicitudes filtradas
  const [solicitudesFiltradas, setSolicitudesFiltradas] = useState([]);

  const {
      rechazarSolicitud,
      confirmDialog, 
      closeConfirmDialog 
    } = useDetalleSolicitudModel();

  //cargar todas las solicitudes
  useEffect(() => {
    console.log("1- CARGANDO SOLICITUDES");
    cargarSolicitudes(false);

    
    const cleanupWebSockets = setupWebSocketsSolicitudes();

    return () => {
      cleanupWebSockets();
    };

  }, []);

  //Extraer materias
  useEffect(() => {
    if (Array.isArray(solicitudesDisponibles) && solicitudesDisponibles.length > 0) {
      // Extraer todas las materias de las solicitudes
      const todasMaterias = solicitudesDisponibles.reduce((acc, sol) => {
        if (sol.materia && typeof sol.materia === 'string') {
          acc.add(sol.materia);
        } else if (Array.isArray(sol.materias)) {
          sol.materias.forEach(mat => {
            if (mat) acc.add(mat);
          });
        }

        if (sol.prediccionIA?.materiaIA) {
          acc.add(sol.prediccionIA.materiaIA);
        }

        return acc;
      }, new Set());
      
      setMateriasDisponibles(Array.from(todasMaterias));
    }
  }, [solicitudesDisponibles]);

  // Cargar y filtrar solicitudes
  useEffect(() => {
    if (solicitudesDisponibles) {
      filtrarYOrdenarSolicitudes();
    }
  }, [solicitudesDisponibles, materiasFiltradas, ordenFecha]);

  const filtrarYOrdenarSolicitudes = () => {
    // Verificar que solicitudesDisponibles sea un array
    if (!Array.isArray(solicitudesDisponibles)) {
      setSolicitudesFiltradas([]);
      return;
    }
    
    let resultado = [...solicitudesDisponibles];

    // Filtrar por materias seleccionadas
    if (materiasFiltradas.length > 0) {
      resultado = resultado.filter(sol => {
        // Manejar cuando es un string
        if (sol.materia && typeof sol.materia === 'string') {
          return materiasFiltradas.includes(sol.materia);
        }
        
        // Manejar cuando es un array
        if (Array.isArray(sol.materias)) {
          return sol.materias.some(materia => materiasFiltradas.includes(materia));
        }
        
        return false;
      });
    }

    // Ordenar por fecha con manejo de errores
    resultado.sort((a, b) => {
      try {
        const fechaA = a.fechaentrega ? new Date(a.fechaentrega) : new Date();
        const fechaB = b.fechaentrega ? new Date(b.fechaentrega) : new Date();
        
        // Ascendente: de más vieja a más reciente
        if (ordenFecha === 'ascendente') {
          return fechaA - fechaB;
        } 
        // Descendente: de más reciente a más vieja (por defecto)
        else {
          return fechaB - fechaA;
        }
      } catch (error) {
        console.error('Error al ordenar fechas:', error);
        return 0;
      }
    });

    setSolicitudesFiltradas(resultado);
  };
 
  // Función para alternar la selección de materias
  const toggleMateria = (materia) => {
      setMateriasFiltradas(prev => {
        if (prev.includes(materia)) {
          // Si ya está en el array, la quitamos
          return prev.filter(m => m !== materia);
        } else {
          // Si no está, la añadimos
          return [...prev, materia];
        }
      });
  };

      //cargar configuracion
  if(loadingConfiguracion){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos de configuracion...</p>
        </div>
      </div>
    );
  }

  if(configuracion === null){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error al cargar datos de configuracion</p>
        </div>
      </div>
    );
  }
  if (loadingSolicitudes) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (errorSolicitudes) {
    return (
      <div className="text-center p-4 text-red-500">
        Error al cargar las solicitudes: {errorSolicitudes}
      </div>
    );
  }

  /**
 * Componente para renderizar una tarjeta de solicitud
 * @param {Object} props - Propiedades del componente
 * @param {Solicitud} solicitud - La solicitud a renderizar
 */
  const cotizarSolicitud = (solicitud) => {
    const nombreEmpresaURL = solicitud.nombreEmpresa.replace(/ /g, '_');
    navigate(`/dashboard/detalle_solicitud/${nombreEmpresaURL}/${solicitud.id}`);
  }

  // Calcular estadísticas
  const calcularEstadisticas = () => {
      if (!solicitudesDisponibles) return { total: 0, urgentes: 0, proximos: 0 };
      
      const hoy = new Date();
      const dosDias = new Date(hoy);
      dosDias.setDate(hoy.getDate() + 2);
      
      const sieteDias = new Date(hoy);
      sieteDias.setDate(hoy.getDate() + 7);
      
      const urgentes = solicitudesDisponibles.filter(sol => {
        const fechaEntrega = new Date(sol.fechaentrega);
        return fechaEntrega <= dosDias;
      }).length;
      
      const proximos = solicitudesDisponibles.filter(sol => {
        const fechaEntrega = new Date(sol.fechaentrega);
        return fechaEntrega >= dosDias
      }).length;
      
      return {
        total: solicitudesDisponibles.length,
        urgentes,
        proximos
      };
  };
  
  const estadisticas = calcularEstadisticas();


  return (
    <div className="p-4">   

      <RevisionTutor
        nombreEmpresa={"DUFY ASESORIAS"}
        nombreTutor={usuario.nombrewhatsapp}
      />

      <div className="w-full rounded-xl border border-gray-200 bg-white p-4 shadow-sm mb-6">

      {/* Contenedor principal con Flexbox para alinear las dos columnas */}
      <div className="flex w-full flex-wrap items-start justify-between gap-4">

        {/* --- COLUMNA IZQUIERDA: Título e Información --- */}
       <div className="text-left">
        
          <h3 className="text-xl font-bold text-gray-900">
            Solicitudes Disponibles
          </h3>
          <div className="mt-1 flex items-start gap-2 text-sm text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0 text-indigo-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.364l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
            <div>
              <span>
                Filtrando por tu carrera (<span className="font-bold text-indigo-600">{usuario.carrera || '...'}</span>) y materias para sugerirte trabajos compatibles.
              </span>
              <p className="text-xs text-gray-500 italic mt-1">
                *Esta es una recomendación automática, nuestra IA aún está aprendiendo.
              </p>
            </div>
          </div>
        </div>
        

        {/* --- COLUMNA DERECHA: Estadísticas y Filtros --- */}
        {/* Este bloque contiene toda tu lógica original de filtros */}
        <div className="flex w-full flex-shrink-0 flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-start lg:w-auto lg:justify-end">
          
          {/* Estadísticas mini */}
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1.5 rounded bg-blue-50 px-2 py-1">
              <span className="text-xs font-medium text-blue-700">{estadisticas.total}</span>
              <span className="text-xs text-blue-600">Total</span>
            </div>
            <div className="flex items-center gap-1.5 rounded bg-red-50 px-2 py-1">
              <span className="text-xs font-medium text-red-700">{estadisticas.urgentes}</span>
              <span className="text-xs text-red-600">Urgentes</span>
            </div>
            <div className="flex items-center gap-1.5 rounded bg-indigo-50 px-2 py-1">
              <span className="text-xs font-medium text-indigo-700">{estadisticas.proximos}</span>
              <span className="text-xs text-indigo-600">Próximos</span>
            </div>
          </div>
          
          {/* Controles de filtro (tu código original) */}
          <div className="flex w-full items-center justify-start gap-2 sm:w-auto sm:justify-end">
            {/* Filtro de materias */}
            <div className="relative">
              <button
                className="flex items-center gap-2 rounded-md bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200"
                onClick={() => setShowMateriasFiltro(!showMateriasFiltro)}
              >
                <span className="text-xs">
                  {materiasFiltradas.length === 0 ? 'Materias' : `${materiasFiltradas.length} filtros`}
                </span>
                <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
              </button>
              {showMateriasFiltro && (
                <div className="absolute right-0 z-10 mt-1 w-64 max-h-60 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
                  <div className="p-3">
                    <div className="mb-3 flex items-center justify-between border-b pb-2">
                      <span className="text-sm font-medium text-gray-900">Filtrar por materia</span>
                      <button className="text-xs text-blue-600 hover:text-blue-800" onClick={() => setMateriasFiltradas([])}>Limpiar</button>
                    </div>
                    {materiasDisponibles.length > 0 ? (
                      <div className="max-h-40 space-y-2 overflow-y-auto">
                        {materiasDisponibles.map((materia) => (
                          <label key={materia} className="flex cursor-pointer items-center rounded p-1 hover:bg-gray-50">
                            <input type="checkbox" checked={materiasFiltradas.includes(materia)} onChange={() => toggleMateria(materia)} className="h-3 w-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                            <span className="text-sm text-gray-900 ml-2">{materia}</span>
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="p-2 text-center text-sm text-gray-500">No hay materias</div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Divisor */}
            <div className="h-6 w-px bg-gray-300"></div>

            {/* Ordenar por fecha */}
            <select
              className="rounded-md border-0 bg-gray-100 px-3 py-2 text-sm text-gray-700 transition-all focus:ring-2 focus:ring-blue-500"
              value={ordenFecha}
              onChange={(e) => setOrdenFecha(e.target.value)}
            >
              <option value="descendente">Más recientes</option>
              <option value="ascendente">Más antiguas</option>
            </select>
          </div>
        </div>
      </div>
      </div>

      {/* Grid de solicitudes */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {solicitudesFiltradas && solicitudesFiltradas.length > 0 ? (
          solicitudesFiltradas.map(solicitud => {
            

            {/* Grid de solicitudes */}

            return <CardSolicitud 
              solicitud={solicitud}
              onRechazar={() => rechazarSolicitud(solicitud.nombreEmpresa, solicitud.id)}
              />
              
            return   <RendersolicitudCard
              key={solicitud.id}
              solicitud={solicitud}
              onCotizar={cotizarSolicitud}
              onRechazar={() => rechazarSolicitud(solicitud.nombreEmpresa, solicitud.id)}
            />;

          },
             
            
          )
        ) : (
          <div className="col-span-full bg-white rounded-lg shadow-md p-6 text-center">
            <div className="text-gray-400 mb-3">
              <svg
                className="w-16 h-16 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                ></path>
              </svg>
            </div>
            <p className="text-lg font-medium">No hay solicitudes disponibles</p>
            <p className="text-gray-500 mt-2">
              {materiasFiltradas.length > 0
                ? 'No hay solicitudes que coincidan con los filtros seleccionados.'
                : 'Vuelve más tarde para ver nuevas solicitudes.'}
            </p>
          </div>
        )}
      </div>

       {/* Modal para rechazar confirmaciones */}
       <ConfirmationDialog 
        isOpen={confirmDialog.isOpen}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={closeConfirmDialog}
      />

    </div>
  );

  
}

export default DashboardSolciitudesTutor
